"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizedGuestService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token", "unitId"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AuthorizedGuestService = exports.AuthorizedGuestService = /*#__PURE__*/(0, _createClass2["default"])(function AuthorizedGuestService() {
  (0, _classCallCheck2["default"])(this, AuthorizedGuestService);
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "list", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get("authorizedVisitors", {
    params: params
  });
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "create", function (_ref2) {
  var token = _ref2.token,
    unitId = _ref2.unitId,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).post("authorizedVisitors?unitId=".concat(unitId), _objectSpread(_objectSpread({}, params), {}, {
    unitId: unitId
  }));
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "delete", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id;
  return _Api["default"].withAuth(token)["delete"]("authorizedVisitors/".concat(id));
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "patch", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded3);
  return _Api["default"].withAuth(token).patch("authorizedVisitors/".concat(id), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "addPhoto", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded4);
  return _Api["default"].withAuth(token).patch("authorizedVisitors/".concat(id, "/visitorPhoto"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AuthorizedGuestService, "removePhoto", function (_ref6) {
  var token = _ref6.token,
    id = _ref6.id;
  return _Api["default"].withAuth(token)["delete"]("authorizedVisitors/".concat(id, "/visitorPhoto"));
});